import SportsManager from './SportsManager';

export default SportsManager;
